import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../../context/useLayoutContext";
import PageMetaData from "../../../components/PageMetaData";
import TopNavBar from "../../../components/TopNavBar";
import FAQs from "../components/FAQs";
import Footer from "../components/Footer";
import { useState } from "react";
import Calculator from "../components/Calculator";

const FAQPage = () => {
  const [showCalculator, setShowCalculator] = useState(false);

  const handleShowCalculator = () => {
    console.log("Calculator button clicked");
    setShowCalculator(!showCalculator);
  };

  return (
    <>
      <HelmetProvider>
        <LayoutProvider>
          <PageMetaData title="Geo Express | FAQs" />
          <TopNavBar
            position="fixed"
            menuItems={[
              ["მთავარი", "home", "/"],
              ["სერვისები", "services", "/services", true],
              ["სიახლეები", "news", "/news"],
              ["კონტაქტი", "contact", "/contact"],
              ["ხშირად დასმული კითხვები", "faqs", "/faq"],
              ["განსაბაჟებელი გზავნილები", "shipment", "/shipment"],
            ]}
            onCalculatorClick={handleShowCalculator}
          />
          <Calculator
            show={showCalculator}
            onClose={() => setShowCalculator(false)}
          />
          <FAQs />
          <Footer />
        </LayoutProvider>
      </HelmetProvider>
    </>
  );
};

export default FAQPage;
